<template>
    <div class="view infra">
      <div class="filters">
        <StoreSelect
          @storeSelected="storeSelected"
          />
        <div class="actions-bar">
          <a class="button white sm download umami--click--descarga-presencia" v-bind:href="downlonadLink">
              <i class="icon ico-download"></i>
              <p>{{downloadTitle}}</p>
            </a>
        </div>
      </div>

        <AmountInfraCard
          @changeRange="showData"
          style="grid-column-start:2"
          title="Ayer"
          class="desktop"
          :initRange="yesterday"
          :endRange="yesterday"
          :selectedRange="this.selectedRange"
          :store_id="store_id"
          tip="Cantidad de dispositivos detectados el día de ayer. Son visitantes los dispositivos detectados por 5 minutos o más durante el día, y transeúntes los dispositivos detectados por menos de dicho lapso de tiempo. El Capture Rate se calcula como el total de visitantes sobre el total de dispositivos detectados (visitantes + transeúntes)."
          titleEmpty=""
          captionEmpty="No contamos con suficientes datos para mostrar información de valor."
          />

        <AmountInfraCard
          @changeRange="showData"
          title="Últimos 7 días"
          :initRange="initRange"
          :endRange="yesterday"
          :selectedRange="this.selectedRange"
          :store_id="store_id"
          tip="Cantidad de dispositivos detectados los últimos 7 días. Son visitantes los dispositivos detectados por 5 minutos o más durante el día, y transeúntes los dispositivos detectados por menos de dicho lapso de tiempo. El Capture Rate se calcula como el total de visitantes sobre el total de dispositivos detectados (visitantes + transeúntes)."
          titleEmpty=""
          captionEmpty="No contamos con suficientes datos para mostrar información de valor."
          />

        <AmountInfraCard
          @changeRange="showData"
          title="Últimos 30 días"
          class="desktop"
          :initRange="initRange30"
          :endRange="yesterday"
          :selectedRange="this.selectedRange"
          :store_id="store_id"
          tip="Cantidad de dispositivos detectados los últimos 30 días. Son visitantes los dispositivos detectados por 5 minutos o más durante el día, y transeúntes los dispositivos detectados por menos de dicho lapso de tiempo. El Capture Rate se calcula como el total de visitantes sobre el total de dispositivos detectados (visitantes + transeúntes)."
          titleEmpty=""
          captionEmpty="No contamos con suficientes datos para mostrar información de valor."
          />

        <BarLineGraphCard
          title="Clasificación"
          tip="Muestra las cantidades de dispositivos detectados, tanto visitantes como transeúntes, del período seleccionado, por día."
          :data="connectionBarChart"
          :periodItems="periods"
          :loader="connectionsLoaded"
          :maxValue="maxValue"
          :maxPasserValue="maxPasserValue"
          :maxVisitorValue="maxVisitorValue"
          :maxPercentage="maxPercentage"
          style="grid-column-start:2"
          titleEmpty=""
          captionEmpty="No contamos con suficientes datos para mostrar información de valor."
          />

        <div class="micro-grid">
          <AmountSingle
            title="Visitantes"
            sub="promedio"
            :amount="averageVisitors"
            amountDesc="visitantes"
            :loader="averageLoaded"
            tip="Promedio diario de visitantes del período seleccionado."
            titleEmpty=""
            captionEmpty="No contamos con suficientes datos para mostrar información de valor."  
            />
          <AmountSingle
            title="Permanencia"
            sub="promedio"
            :amount="this.dwellTimeAvg"
            amountDesc="minutos"
            :loader="this.dwellTimeAvgLoaded"
            tip="Tiempo promedio de permanencia, en minutos, de los visitantes del período seleccionado."
            titleEmpty=""
            captionEmpty="Datos insuficientes"
            />
        </div>

        <AmountDwellTime
          title="Distribución de visitantes por tiempo de permanencia"
          class="distribucion"
          :data="totalDwellTime"
          :loader="dwellTimeLoaded"
          tip="Porcentaje de visitantes que fue detectado por rango de tiempo de permanencia en el período seleccionado."
          titleEmpty="Este gráfico no está disponible actualmente"
          captionEmpty="No contamos con suficientes datos para mostrar información de valor."
          />

        <LineGraphCard
          title="Recurrencia de los visitantes"
          class="desktop"
          :data="recurrentsLineChart"
          :periodItems="periods"
          :loader="recurrentsLoaded"
          :md="true"
          style="grid-column-start:2"
          tip="Cantidad de dispositivos visitantes nuevos y recurrentes del período seleccionado. Un dispositivo es nuevo si fue detectado sólo una vez en el período seleccionado, y recurrente si fue detectado más de una vez."
          titleEmpty="Este gráfico no está disponible actualmente"
          captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
          />

        <GraphCard
          title="Recurrencia"
          class="recurrencia"
          sub="Visitantes"
          :sm="true"
          :detailed="[totalNotRecurrents, totalRecurrents]"
          :detailedNames="['Nuevos', 'Recurrentes']"
          :loader="recurrentsLoaded"
          tip="Porcentaje de dispositivos visitantes nuevos y recurrentes del período seleccionado. Un dispositivo es nuevo si fue detectado sólo una vez en el período seleccionado, y recurrente si fue detectado más de una vez."
          titleEmpty="Este gráfico no está disponible actualmente"
          captionEmpty="No contamos con suficientes datos para mostrar información de valor. Tan pronto podamos, lo mostraremos"
          />
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'
import AmountInfraCard from '@/components/cards/AmountInfraCard'
import AmountDwellTime from '@/components/cards/AmountDwellTime'
import AmountSingle from '@/components/cards/AmountSingle'
import GraphCard from '@/components/cards/GraphCard'
import BarLineGraphCard from '@/components/cards/BarLineGraphCard'
import LineGraphCard from '@/components/cards/LineGraphCard'
import StoreSelect from '@/components/StoreSelect'

import { mapActions } from 'vuex'

export default {
    name : 'Infra',
    data: function(){
        return {
            initRange: moment().subtract(7,'d').format('YYYY-MM-DD'),
            initRange30: moment().subtract(30, 'd').format('YYYY-MM-DD'),
            yesterday: moment().subtract(1, 'd').format('YYYY-MM-DD'),
            selectedRange: this.initRange,
            store_id: "999999",
            connectionBarChart: [],
            periods: [],
            maxValue: 0,
            maxPasserValue: 0,
            maxVisitorValue: 0,
            maxPercentage:0,
            connectionsLoaded: false,
            averageVisitors: 0,
            averageLoaded: false,
            dwellTimeLoaded: false,
            totalDwellTime: {
              fiveMins: 0,
              twentyMins: 0,
              sixtyMins: 0
            },
            dwellTimeAvg: 0,
            dwellTimeAvgLoaded: false,
            totalRecurrents: 0,
            totalNotRecurrents: 0,
            recurrentsLineChart: [],
            recurrentsLoaded: false,
            downloadTitle: "Descarga últimos 30 días",
            csvExportTranseuntes: [],
            csvExportVisitantes: [],
            csvExportCaptureRate: [],
            csvExportDataRecurrents: [],
            csvExportDataNotRecurrents: [],
            csvExportDataPeriods: [],
            csvExportDataSumConnection: 0,
            cvsDataReady: false,
            cvsValidPeriod: false,
            downlonadLink: ""
        }
    },
    components: {
        AmountInfraCard,
        GraphCard,
        BarLineGraphCard,
        LineGraphCard,
        StoreSelect,
        AmountSingle,
        AmountDwellTime
    },
    mounted: function(){
        this.$store.dispatch("auth/setActive", "infra")
        this.selectedRange = this.initRange
        let downloadInitDate = moment().subtract(1,'d').format('DD-MM-YYYY')
        this.downlonadLink = "https://notros-clientes.s3.us-east-1.amazonaws.com/"+ process.env.VUE_APP_CLIENT_NAME_S3 +"/reports/"+downloadInitDate+"-"+process.env.VUE_APP_CLIENT_NAME+"-sessions.csv"
    },
    methods: {
      thousandseparatos: function(num){
        var num_parts = num.toString().split(".");
        num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return num_parts.join(".");
      },
      csvExport: function() {

        let totalTranseuntes = 0
        let totalVisitantes = 0
        let totalCaptureRate = 0
        let totalRecurrents = 0
        let totalNotRecurrents = 0

        _.each(this.csvExportTranseuntes, (value) => {
          totalTranseuntes = totalTranseuntes + value.value
        })

        _.each(this.csvExportVisitantes, (value) => {
          totalVisitantes = totalVisitantes + value.value
        })

        _.each(this.csvExportCaptureRate, (value) => {
          totalCaptureRate = totalCaptureRate + value.value
        })

        _.each(this.csvExportDataRecurrents, (value) => {
          totalRecurrents = totalRecurrents + value.value
        })

        _.each(this.csvExportDataNotRecurrents, (value) => {
          totalNotRecurrents = totalNotRecurrents + value.value
        })

        let periodRecurrentNotrecurrent = []
        
        _.each(this.csvExportDataPeriods, (value) => {
          let period = {}
          period["Período"] = value
          
          _.each(this.csvExportTranseuntes, (value) => {
            if (period["Período"] === value.period){
                period["Transeúntes"] = this.thousandseparatos(value.value)
            }
          })

          _.each(this.csvExportVisitantes, (value) => {
            if (period["Período"] === value.period){
                period["Visitantes"] = this.thousandseparatos(value.value)
            }
          })

          _.each(this.csvExportCaptureRate, (value) => {
            if (period["Período"] === value.period){
                period["Capture_rate"] = value.value.toString()+"%"
            }
          })

          _.each(this.csvExportDataRecurrents, (value) => {
            if (period["Período"] === value.period){
                period["Recurrentes"] = this.thousandseparatos(value.value)
            }
          })

          _.each(this.csvExportDataNotRecurrents, (value) => {
            if (period["Período"] === value.period){
                period["No_recurrentes"] = this.thousandseparatos(value.value)
            }
          })

          periodRecurrentNotrecurrent.push(period)
          
        })

          let capturePercentage = (totalCaptureRate / this.csvExportCaptureRate.length).toFixed(0).toString()+"%"

          let spaceperiod = {}
          spaceperiod["Período"] = ""
          spaceperiod["Transeúntes"] = ""
          spaceperiod["Visitantes"] = ""
          spaceperiod["Capture_rate"] = ""
          spaceperiod["Recurrentes"] = ""
          spaceperiod["No_recurrentes"] = ""
          periodRecurrentNotrecurrent.push(spaceperiod)

          let totalperiod = {}
          totalperiod["Período"] = "Total"
          totalperiod["Transeúntes"] = this.thousandseparatos(totalTranseuntes)
          totalperiod["Visitantes"] = this.thousandseparatos(totalVisitantes)
          totalperiod["Capture_rate"] = capturePercentage
          totalperiod["Recurrentes"] = this.thousandseparatos(totalRecurrents)
          totalperiod["No_recurrentes"] = this.thousandseparatos(totalNotRecurrents)
          periodRecurrentNotrecurrent.push(totalperiod)

        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [
          Object.keys(periodRecurrentNotrecurrent[0]).join(";"),
          ...periodRecurrentNotrecurrent.map(item => Object.values(item).join(";"))
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", data);
        link.setAttribute("download", moment().format('DD-MM-YYYY')+"_Notros_Presencia.csv");
        link.click();
      },
      storeSelected: function(id){
        
        // this.connectionsLoaded = false
        this.store_id = id
        // document.getElementsByClassName("card-data sm active")[0].click()
      },
      showData: function(init, end, passersBy, visitors){
        this.csvExportCaptureRate = []
        this.csvExportDataRecurrents = []
        this.csvExportDataNotRecurrents = []

        this.selectedRange = init
        this.connectionsLoaded = false
        this.averageLoaded = false
        this.recurrentsLoaded = false
        if (init == this.initRange30){
          this.changeMaxRange(true)
          this.cvsValidPeriod = true
        } else {
          this.changeMaxRange(false)
        }

        if (init == this.yesterday) {
          this.changeOneDayLineRange(true)
          this.cvsValidPeriod = false
        } else {
          this.changeOneDayLineRange(false)
        }

        if(init != this.initRange30 && init != this.yesterday){
          this.cvsValidPeriod = true
        }

        let totalVisitors = 0
        let periods = []

        let passers_periods = []
        let visitors_periods = []
        let capture_rate_periods = []
        
        let connectedChartData = [
          {
            'name': 'Capture rate',
            'type': 'line',
            'data': []
          },
          {
            'name': 'Transeúntes',
            'type': 'bar',
            'data': []
          },
          {
            'name': 'Visitantes',
            'type': 'bar',
            'data': []
          }          
        ]

        let maxValue = 0
        let maxPasserValue = 0
        let maxVisitorValue = 0
        let maxPercentage = 0

        _.each(passersBy, (value) => {
          periods.push(value.period)
          connectedChartData[1].data.push(value.value)

          if(value.value > maxPasserValue){
            maxPasserValue = value.value
          }
          
          passers_periods.push(value)

        })

        this.csvExportTranseuntes = passers_periods
        this.csvExportDataPeriods = periods

        _.each(visitors, (value) => {
          connectedChartData[2].data.push(value.value)
          totalVisitors = totalVisitors + value.value

          if(value.value > maxVisitorValue){
            maxVisitorValue = value.value
          }

          visitors_periods.push(value)

        })

        this.csvExportVisitantes = visitors_periods

        _.each(passers_periods, (passer) => {
          _.each(visitors_periods, (visitor) => {
            if(passer.period.indexOf(visitor.period)==0){
              
              var capture_rate = parseFloat(((visitor.value * 100) / (passer.value + visitor.value)).toFixed(1))

              if (isNaN(capture_rate)){
                capture_rate = 0
              }
              
              capture_rate_periods.push(capture_rate)
              connectedChartData[0].data.push(capture_rate)

              if(capture_rate > maxPercentage){
                maxPercentage = capture_rate
              }

              this.csvExportCaptureRate.push({'period':passer.period,'value':capture_rate})

            }
          })
        })

        maxValue = maxPasserValue+maxVisitorValue
        // maxPercentage = maxPercentage
        this.averageVisitors = totalVisitors / visitors.length
        this.averageLoaded = true
        this.connectionBarChart = connectedChartData
        this.maxValue = maxValue
        this.maxPasserValue = maxPasserValue
        this.maxVisitorValue = maxVisitorValue
        this.maxPercentage = maxPercentage
        this.periods = periods
        setTimeout(() => this.connectionsLoaded = true, 300)
        this.showDwellTime(init, end)
        this.showRecurrents(init, end)

        if(this.totalVisitors==0){
          this.averageVisitors=0
          }

      },
      showDwellTime: function(init, end){

        let headers = {
          'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
        }
        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/dwell_time/?store_id="+this.store_id+"&init_date="+init+"&end_date="+end, {
          headers: headers
        })
          .then((res) => {
            let sum5Min = 0;
            let sum60Min= 0;
            let sum6Hour = 0;
            let total = 0;
            _.each(res.data, (value) => {
              total = total + value.value
              if (value.name == 'DWELL_FIVE_TO_SIXTY_MINUTES') {
                sum5Min = sum5Min + value.value
              } else if (value.name == 'DWELL_ONE_TO_SIX_HOURS') {
                sum60Min= sum60Min+ value.value
              } else if (value.name == 'DWELL_SIX_PLUS_HOURS') {
                sum6Hour = sum6Hour + value.value
              }
            })
            this.totalDwellTime.fiveMins = sum5Min;
            this.totalDwellTime.twentyMins = sum60Min
            this.totalDwellTime.sixtyMins = sum6Hour;
            this.showDwellTimeAvg(init, end)
            this.dwellTimeLoaded = true;
          })
          .catch(() => {
            // console.log(err.data)
            this.dwellTimeLoaded = false;
          })
      },
      showDwellTimeAvg: function(init, end){
        let headers = {
          'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
        }
        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/average_dwell_time/?init_date="+init+"&end_date="+end+"&store_id="+this.store_id, {
          headers: headers
        })
          .then((res) => {
            let totalAverageDwellTime = 0
            _.each(res.data, (value) => {
              totalAverageDwellTime = totalAverageDwellTime + value.value
            })

            this.dwellTimeAvg = totalAverageDwellTime / res.data.length
            this.dwellTimeAvgLoaded = true;
          })
          .catch(() => {
            // console.log(err)
            this.dwellTimeAvg = null
            this.dwellTimeAvgLoaded = false;
          })
      },
      showRecurrents: function(init, end){
        let headers = {
          'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
        }
        axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/infrastructure/recurrents/?init_date="+init+"&end_date="+end+"&store_id="+this.store_id, {
          headers: headers
        })
          .then((res) => {
            let totalRecurrents = 0
            let totalNotRecurrents = 0
            let recurrentChartData = [
              {
                'name': 'Nuevos',
                'data': []
              }, 
              {
                'name': 'Recurrentes',
                'data': []
              }
            ]

            let newData = res.data.sort(function (a,b) {
              return moment(a.period, 'DD-MM-YYYY').unix() - moment(b.period, 'DD-MM-YYYY').unix()
            });
            _.each(newData, (value) => {
              recurrentChartData[1].data.push(value.recurrents)

              recurrentChartData[0].data.push(value.not_recurrents)

              totalRecurrents = totalRecurrents + value.recurrents
              totalNotRecurrents = totalNotRecurrents + value.not_recurrents

              this.csvExportDataRecurrents.push({'period':value.period,'value':value.recurrents})
              this.csvExportDataNotRecurrents.push({'period':value.period,'value':value.not_recurrents})
            })

            if(init != end){
              this.totalNotRecurrents = totalNotRecurrents
              this.totalRecurrents = totalRecurrents
            }
            else if (init == end){
              let inicio = moment().subtract(7,'d').format('YYYY-MM-DD')
              let lastDay = moment().subtract(1,'d').format('DD-MM-YYYY')
              let headers = {
                'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
              }
              axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/infrastructure/recurrents/?init_date="+inicio+"&end_date="+end+"&store_id="+this.store_id, {
                headers: headers
              })
              
              .then((res) => {
                for ( let i=0; i <= res.data.length; i++){
                  if(Object.values(res.data[i]).includes(lastDay))
                 {
                   this.totalNotRecurrents = res.data[i].not_recurrents
                   this.totalRecurrents = res.data[i].recurrents
                  }
                }
              })
            }
            this.recurrentsLineChart = recurrentChartData
            setTimeout(() => this.recurrentsLoaded = true, 300)


            this.cvsDataReady = true
          })
          .catch(() => {
            // console.log(err)
            // this.recurrentsLineChart=[]
            this.recurrentsLoaded = true
          })
      },
      ...mapActions('auth', [
        'changeMaxRange',
        'changeOneDayLineRange'
      ])
    }
}
</script>

<style lang="sass">
.view.infra 
  .filters
    grid-column: 2/5
    display: flex
    justify-content: space-between
    @include mobile
      flex-direction: column
      grid-column: 2/4
    @include mobile-landscape
      grid-column: 2/4
    @include tablet-landscape
      grid-column: 2/5
  .card-data
    &.sm
      .EmptyStateChart
        min-height: 100px
        .border
          padding: 8px
          margin: 8px
          @include tablet-landscape
            margin: 0px
          @include tablet-portrait
            font-size: 12px
            min-height: 60px
.view.infra
  grid-template-columns: 80px repeat(3,minmax(0, 1fr)) 66px
  @include mobile
    grid-template-columns: 8px repeat(2, minmax(0, 1fr)) 8px
  @include mobile-landscape
    grid-template-columns: 8px repeat(2, minmax(0, 1fr)) 8px
  @include tablet-landscape
    grid-template-columns: 4px repeat(3,minmax(0,1fr)) 4px
  @include tablet-portrait
    grid-template-columns: 4px repeat(3,minmax(0,1fr)) 4px
  .actions-bar
    display: flex
    align-items: center
    grid-column-start: 4
    grid-column-end: 5
    justify-content: flex-end
    @media (max-width:$phone)
      grid-column-start: 2
      grid-column-end: 4
    .download
      width: 260px
      @media (max-width:$phone)
        width: 100%
  .desktop
    @include mobile-landscape
      display: none
  .card-data.sm.active
    @include mobile-landscape
      grid-column: 2/4
  .card-data.lg
    @include mobile-landscape
      grid-column: 2/4
  .distribucion
    @include mobile-landscape
      grid-column: 3/4
  .recurrencia
    @include mobile-landscape
      grid-column: 2/4
.view.infra .filters
  margin-bottom: $md
.view .filters
  margin-bottom: $md
  grid-column-start: 2
  grid-column-end: span 2
  @media (max-width: $tablet)
    margin-top: 32px
    margin-bottom: 32px
  
.section
  grid-column-start: 2
  grid-column-end: span 4
  @media (max-width: $tablet)
    grid-column-end: span 1
.section-title
  font-family: Montserrat
  font-size: 24px
  color: #ffffff
.micro-grid
  grid-column-start: 2
  grid-column-end: 3
  display: grid
  grid-template-columns: repeat(2, minmax(0,1fr))
  grid-column-gap: 8px
  align-items: stretch
  justify-items: center
  @include mobile
    grid-column-end: span 2
    grid-row-gap: 8px
    .card-data
      grid-column-start: auto
      grid-column-end: span 1  
    .card-title
      align-items: center
      display: grid
  .EmptyStateChart
    min-height: 80px
    .border
      margin: 8px
      padding: 8px
      @include tablet-portrait
        margin: 0px
        width: 80px
        padding: 4px
        max-width: 90px
        .caption
          font-size: 12px
</style>